var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"on-topic-no-picture"},[_c('div',{staticClass:"content"},[_c('PostTitle',{attrs:{"title":_vm.title,"permalink":_vm.link,"tag":"h4"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }